import onElementExists from "../lib/onElementExists"
import { lockScroll, unlockScroll } from "./lockScroll";

let queue : HTMLDialogElement[] = []

const openDialog = (dialog : HTMLDialogElement) => {
  dialog.dataset.wasAutoOpened = "true";
  dialog.showModal()
  lockScroll();
}

// Auto-open any dialog that appears in the DOM and requests auto-open via data-auto-open aka data: {auto_open: true}
// Opens matching elements one by one in a queue.
onElementExists("dialog[data-auto-open]", (dialog : HTMLDialogElement) => {
  if(dialog.dataset.wasAutoOpened) return; // Don't re-open a closed dialog that turbo cache (temporarily) recreates
  const onclose = (_e) => {
    unlockScroll()
    queue = queue.filter(d => d != dialog)
    if(queue[0] && !queue[0].open) openDialog(queue[0])
  }
  dialog.addEventListener('close', onclose)
  queue.push(dialog)
  if(queue[0] == dialog) openDialog(dialog)
  return onclose; // Will be called by onElementExists if/when the element ceases to exist
})
